import React from 'react'
import PropTypes from 'prop-types'
import {Input} from 'antd'
import {MinusOutlined, PlusOutlined} from '@ant-design/icons'
import Button from 'components/shared/Button'

class QuantityField extends React.Component {
  static propTypes = {
    value: PropTypes.number,
    onChange: PropTypes.func,
    minValue: PropTypes.number,
    maxValue: PropTypes.number,
  }

  static defaultProps = {
    minValue: 1,
    maxValue: 1000,
    onChange: null,
    value: 1,
  }

  constrainQuantity = (value) => {
    if (!Number.isInteger(value)) return null
    return Math.max(
      Math.min(value, this.props.maxValue),
      this.props.minValue
    )
  }

  onChange = (e) => {
    const value = e.target.value
    if (this.props.onChange) {
      const integerValue = parseInt(value, 10) || null
      this.props.onChange(integerValue)
    }
  }

  onBlur = () => {
    this.props.onChange(
      this.constrainQuantity(this.props.value)
    )
  }

  increment = (e) => {
    e.preventDefault()
    this.props.onChange(
      this.constrainQuantity(this.props.value + 1)
    )
  }

  decrement = (e) => {
    e.preventDefault()
    this.props.onChange(
      this.constrainQuantity(this.props.value - 1)
    )
  }

  render() {
    return (
      <div className="quantity-field">
        <Button icon={<MinusOutlined />} onClick={this.decrement} />

        <Input
          pattern="\d*"
          value={this.props.value || ''}
          onChange={this.onChange}
          onBlur={this.onBlur}
        />

        <Button icon={<PlusOutlined />} onClick={this.increment} />
      </div>
    )
  }
}

export default QuantityField
